import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { BookOpen, FileDown, Plus, Edit, Trash2, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CommuneJournalTab = ({ journal, token, canEditJournal, openDlg, deleteItem }) => (
    <Card className="content-card">
        <CardHeader className="card-header"><div className="flex items-center justify-between w-full">
            <CardTitle className="card-title flex items-center gap-2"><BookOpen className="w-5 h-5 text-cyan-500" /> Journal de bord ({journal.length})</CardTitle>
            <div className="flex items-center gap-2">
                {journal.length > 0 && <a href={`${API}/journal-bord/export?token=${token}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 h-8 px-3 rounded-md text-xs font-medium bg-cyan-600/20 border border-cyan-500/30 text-cyan-400 hover:bg-cyan-600/30" data-testid="export-journal-btn"><FileDown className="w-3.5 h-3.5" /> PDF</a>}
                {canEditJournal && <Button size="sm" className="tactical-btn" onClick={() => openDlg('journal', { event_time: new Date().toISOString().slice(0, 16), description: '', category: 'general' })} data-testid="add-journal-btn"><Plus className="w-4 h-4 mr-1" /> Ajouter</Button>}
            </div>
        </div></CardHeader>
        <CardContent className="p-0 max-h-[60vh] overflow-y-auto">
            {journal.map((e, i) => (
                <div key={e.id} className={`px-4 py-3 flex items-start gap-3 ${i > 0 ? 'border-t border-zinc-800' : ''} ${e.auto ? 'opacity-60' : ''}`}>
                    <div className={`w-1 h-full min-h-[40px] rounded shrink-0 ${e.auto ? 'bg-zinc-600' : 'bg-cyan-500/40'}`}></div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 text-xs text-zinc-500"><Clock className="w-3 h-3" /> {e.event_time?.slice(0, 16).replace('T', ' ')} <Badge variant="outline" className="text-[9px] border-zinc-700">{e.category}</Badge> <span>— {e.created_by}</span> {e.auto && <Badge variant="outline" className="text-[9px] border-zinc-700/50 text-zinc-600">auto</Badge>}</div>
                        <p className="text-sm text-zinc-200 mt-1">{e.description}</p>
                    </div>
                    {canEditJournal && !e.auto && <div className="flex gap-1 shrink-0">
                        <Button size="sm" variant="ghost" className="text-zinc-400 h-7 w-7 p-0" onClick={() => openDlg('journal', e, true)}><Edit className="w-3.5 h-3.5" /></Button>
                        <Button size="sm" variant="ghost" className="text-red-500 h-7 w-7 p-0" onClick={() => deleteItem('/journal-bord', e.id)}><Trash2 className="w-3.5 h-3.5" /></Button>
                    </div>}
                </div>
            ))}
            {journal.length === 0 && <p className="text-center py-8 text-zinc-500">Aucune entree</p>}
        </CardContent>
    </Card>
);

export default CommuneJournalTab;
